// ─── Library feature design tokens ───────────────────────────────────────────
// Central home for the feature's shared constants (colours, sizes, layout). Component-private
// dimensions may still live next to their component; anything shared across the feature lives here.

// Neutral accent for primary buttons, active toggles and focus rings — colour in the Library comes from
// file-type badges and status chips, not a brand tint (matches the new dashboard's brand-neutral controls).
export const LIB_NEUTRAL = '#0F172A'

// Folders share one warm "manila folder" motif: a soft pastel gold fill on a very light tint.
export const FOLDER_ICON_COLOR = '#FCD34D'
export const FOLDER_ICON_BG = '#FEF9E7'
// Readable gold for small outline glyphs (the pastel fill above is too light on white).
export const FOLDER_GLYPH_COLOR = '#D97706'

// Folder nesting cap: root (1) → sub-folder (2) → sub-sub-folder (3).
export const MAX_FOLDER_DEPTH = 3

// Grid tile sizing — kept in one place so cards and their loading skeletons share the exact footprint.
export const LIBRARY_CARD_ICON_PX = 80
export const GRID_CELL_HEIGHT = 245
export const GRID_MIN_COL_WIDTH = 224
export const LIST_ROW_HEIGHT = 61

// Library-only: file types we DOWNLOAD instead of opening in the Office web viewer. The Office viewer chokes
// on our long STS-token presigned URLs ("problem talking to the service"), so for Word docs we skip it and
// hand the user a direct download. Scoped to this feature — other features still use the cloud viewer.
export const DRIVE_DOWNLOAD_EXTENSIONS = ['doc', 'docx']

// Global search behaviour.
export const SEARCH_MIN_QUERY_LENGTH = 2
export const SEARCH_MAX_RESULTS = 50
export const SEARCH_DEBOUNCE_MS = 180
